import React from "react";
import styled from "styled-components";
import moment from "moment";
import loader from "../assets/loader.svg";
import smallLoader from "../assets/loader-small.svg";
import { Link, withRouter, Redirect } from "react-router-dom";
import { baseUrl } from "./url";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./react_date_override.css";
import { DateRangePicker } from "react-dates";

import convertToCsv from "../services/arrayToCSV";
import Modal from './modal/Modal';
import ConfirmPassword from './ConfirmPassword';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

const PaperStyle = {
  flexGrow: 1,
  height: "71px",
  background: "#FFFFFF",
  boxShadow:
    "0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05)",
  borderRadius: "3px 3px 0px 0px"
};

const FilterUserBtnStyle = {
  marginRight: "10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};

const FilterUserButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #6c63ff;
  background: linear-gradient(
    0deg,
    rgba(124, 116, 254, 0.04),
    rgba(124, 116, 254, 0.04)
  );
  border: 1px solid #7c74fe;
  box-sizing: border-box;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);
  border-radius: 3px;
  transform: rotate(0.06deg);
  padding: 0 18px;
`;
const FilterUsersSpan = styled.span`
  margin-right: 20px;
  cursor: pointer;
`;

const FilterUserSubHeading = styled.p`
  color: #4d555e;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  text-transform: uppercase;
  color: #4d555e;
  padding: 0 10px;
`;

const FilterItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterSelect = styled.select`
  height: 36px;
  padding: 2px 10px;
  background: linear-gradient(
    0deg,
    rgba(124, 116, 254, 0.04),
    rgba(124, 116, 254, 0.04)
  );
  border: 1px solid #ededee;
  box-sizing: border-box;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.05);
  border-radius: 3px;
  transform: rotate(0.06deg);
`;

const EditButton = styled.a`
  width: 72px;
  height: 26px;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15),
    0px 0px 0px rgba(63, 63, 68, 0.05);
  border: 1px solid #6c63ff;
  padding: 5.1px 25px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #6c63ff !important;
`;

const ClearFilterSpan = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #6c63ff;
  text-transform: lowercase;
  padding: 0 10px;
  cursor: pointer;
`;

const FilterDateRange = styled.div`
  height: 36px;
  padding: 2px 10px;
`;

class Users extends React.Component {
  constructor() {
    super();
    this.state = {
      currentPage: 1,
      totalPages: 0,
      totalUsers: 0,
      archivedUsersCurrentPage: 1,
      archivedUsersTotalPages: 0,
      totalArchivedUsers: 0,
      archivedUsers: [],
      users: [],
      response: false,
      archivedUsersResponse: false,
      userType: "",
      archivedUserType: "",
      more: 0,
      archivedUserMore: 0,
      moreResponse: true,
      archivedMoreResponse: true,
      tabValue: 0,
      filterActiveUsers: false,
      filterArchivedUsers: false,
      dateAdded: "",
      archivedDateAdded: "",
      activeUserTypeSelected: false,
      archivedUserTypeSelected: false,
      clearDateAdded: true,
      clearLastActive: true,
      startDateDateAddedActive: null,
      endDateDateAddedActive: null,
      focusedInputDateAddedActive: null,
      startDateLastActiveActive: null,
      endDateLastActiveActive: null,
      focusedInputLastActiveActive: null,
      activeLastActiveStart: null,
      activeLastActiveEnd: null,
      activeDateAddedStart: null,
      activeDateAddedEnd: null,
      activeDateAddedSelected: false,
      activeLastActiveSelected: false,
      startDateLastActiveArchived: null,
      endDateLastActiveArchived: null,
      archivedLastActiveStart: null,
      archivedLastActiveEnd: null,
      archivedLastActiveSelected: false,
      focusedInputLastActiveArchived: null,
      startDateDateAddedArchived: null,
      endDateDateAddedArchived: null,
      archivedDateAddedStart: null,
      archivedDateAddedEnd: null,
      archivedDateAddedSelected: false,
      focusedInputDateAddedArchived: null,
      lastActive: '',
      archivedLastActive: '',
      showModal: false,
      selectedUserType: '',
      selectedUserId: ''
    };
    this.showUser = this.showUser.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.loadMoreArchivedUsers = this.loadMoreArchivedUsers.bind(this);
    this.fetchUsers = this.fetchUsers.bind(this);
    this.fetchArchivedUsers = this.fetchArchivedUsers.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleArchivedFilter = this.handleArchivedFilter.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.toggleActiveUserFilter = this.toggleActiveUserFilter.bind(this);
    this.setDateAdded = this.setDateAdded.bind(this);
    this.setLastActive = this.setLastActive.bind(this);
    this.setStartDate = this.setStartDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    this.handleDatesChange = this.handleDatesChange.bind(this);
    this.setFocusedInput = this.setFocusedInput.bind(this);
    this.fetchExportData = this.fetchExportData.bind(this);
    this.handleFilteredExport = this.handleFilteredExport.bind(this);
    this.clearActiveUserFilter = this.clearActiveUserFilter.bind(this);
    this.clearActiveDateAddedFilter = this.clearActiveDateAddedFilter.bind(
      this
    );
    this.clearArchivedUserFilter = this.clearArchivedUserFilter.bind(this);
    this.toggleArchivedUserFilter = this.toggleArchivedUserFilter.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleFocusChanged = this.handleFocusChanged.bind(this);
    this.clearActiveLastActiveFilter = this.clearActiveLastActiveFilter.bind(
      this
    );
    this.clearArchivedLastActiveFilter = this.clearArchivedLastActiveFilter.bind(this);
    this.clearArchivedDateAddedFilter = this.clearArchivedDateAddedFilter.bind(this);
  }
  componentWillMount() {
    let usertype = localStorage.getItem("all_users_type");
    if (usertype !== "") {
      this.setState({
        userType: usertype || ""
      });
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);

    this.fetchUsers(this.state.currentPage);
    this.fetchArchivedUsers(this.state.currentPage);
    localStorage.setItem("all_users_type", "");
  }
  fetchUsers(value) {
    const token = localStorage.getItem("access_token");
    let retries = 0;
    let {
      userType,
      dateAdded
    } = this.state;

    let fetchUsersURL = `${baseUrl}/admin/users?page=${value}&user_type=${userType}&date_added=${dateAdded}`;
    if (
      this.state.activeLastActiveStart !== null &&
      this.state.activeLastActiveEnd
    ) {
      fetchUsersURL += `&last_active[start]=${this.state.activeLastActiveStart}&last_active[end]=${this.state.activeLastActiveEnd}`;
    }

    if (this.state.activeDateAddedStart && this.state.activeDateAddedEnd) {
      fetchUsersURL += `&date_added[start]=${this.state.activeDateAddedStart}&date_added[end]=${this.state.activeDateAddedEnd}`;
    }

    fetch(fetchUsersURL, {
      method: "GET",
      headers: {
        Authorization: token,
        Accept: "application/json"
      }
    })
      .then(response => {
        const auth = response.headers.get("Authorization");
        localStorage.setItem("access_token", auth);
        if (response.status === 403) {
          localStorage.removeItem("access_token");
          return <Redirect to="/login" />;
        }
        return response.json();
      })
      .then(responseJson => {
        if (responseJson.meta.current_page === 1) {
          this.setState({
            users: responseJson.data,
            totalPages: responseJson.meta.last_page,
            totalUsers: responseJson.meta.total,
            more: responseJson.meta.total - 10,
            response: true
          });
        } else {
          for (let user in responseJson.data) {
            this.setState({
              users: [...this.state.users, responseJson.data[user]],
              totalPages: responseJson.meta.last_page,
              totalUsers: responseJson.meta.total,
              moreResponse: true
            });
          }
        }
      })
      .catch(error => {
        if (error === 401 && retries < 1) {
          localStorage.getItem("access_token").then(value => {
            fetch(`${baseUrl}/token/refresh`, {
              headers: {
                Accept: "application/json",
                Authorization: value
              }
            }).then(response => {
              retries += 1;
              if (response.status === 200) {
                localStorage.setItem(
                  "access_token",
                  response.headers.get("Authorization")
                );
                this.handleSubmit();
              } else {
                alert("something went wrong please try again later");
              }
            });
          });
        } else {
          alert("something went wrong please try again later");
        }
      });
  }

  handleFilteredExport() {
    const token = localStorage.getItem("access_token");
    let retries = 0;
    let URL = "";

    if (this.state.tabValue === 0) {
      let { userType, dateAdded, lastActive } = this.state;
      URL = `${baseUrl}/admin/users?archived=0&export=1&user_type=${userType}&date_added=${dateAdded}&last_active=${lastActive}`;
    } else if (this.state.tabValue === 1) {
      let {
        archivedUserType,
        archivedDateAdded,
        archivedLastActive
      } = this.state;
      URL = `${baseUrl}/admin/users?archived=1&export=1&user_type=${archivedUserType}&date_added=${archivedDateAdded}&last_active=${archivedLastActive}`;
    }

    fetch(URL, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: token
      }
    })
      .then(response => {
        const auth = response.headers.get("Authorization");
        localStorage.setItem("access_token", auth);
        if (response.status === 403) {
          localStorage.removeItem("access_token");
          return <Redirect to="/login" />;
        }
        return response.json();
      })
      .then(responseJson => {
        let result = [];
        result.push([
          "Name",
          "Alias",
          "Date Added",
          "User Type",
          "Last Active",
          "Contact"
        ]);
        responseJson.data.forEach(item => {
          result.push([
            item.name,
            item.alias,
            item.date_added,
            item.user_type,
            item.last_active,
            item.contact
          ]);
        });
        this.handleExport(result);
      })
      .catch(error => {
        if (error === 401 && retries < 1) {
          localStorage.getItem("access_token").then(value => {
            fetch(`${baseUrl}/token/refresh`, {
              headers: {
                Accept: "application/json",
                Authorization: value
              }
            }).then(response => {
              retries += 1;
              if (response.status === 200) {
                localStorage.setItem(
                  "access_token",
                  response.headers.get("Authorization")
                );
                this.handleSubmit();
              } else {
                alert("something went wrong please try again later");
              }
            });
          });
        } else {
          alert("something went wrong please try again later");
        }
      });
  }

  fetchExportData() {
    const token = localStorage.getItem("access_token");
    let retries = 0;
    let URL = "";

    if (this.state.tabValue === 0) {
      URL = `${baseUrl}/admin/users?archived=0&export=1`;
    } else if (this.state.tabValue === 1) {
      URL = `${baseUrl}/admin/users?archived=1&export=1`;
    }

    fetch(URL, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: token
      }
    })
      .then(response => {
        const auth = response.headers.get("Authorization");
        localStorage.setItem("access_token", auth);
        if (response.status === 403) {
          localStorage.removeItem("access_token");
          return <Redirect to="/login" />;
        }
        return response.json();
      })
      .then(responseJson => {
        let result = [];
        result.push([
          "Name",
          "Alias",
          "Date Added",
          "User Type",
          "Last Active",
          "Contact"
        ]);
        responseJson.data.forEach(item => {
          result.push([
            item.name,
            item.alias,
            item.date_added,
            item.user_type,
            item.last_active,
            item.contact
          ]);
        });
        this.handleExport(result);
      })
      .catch(error => {
        if (error === 401 && retries < 1) {
          localStorage.getItem("access_token").then(value => {
            fetch(`${baseUrl}/token/refresh`, {
              headers: {
                Accept: "application/json",
                Authorization: value
              }
            }).then(response => {
              retries += 1;
              if (response.status === 200) {
                localStorage.setItem(
                  "access_token",
                  response.headers.get("Authorization")
                );
                this.handleSubmit();
              } else {
                alert("something went wrong please try again later");
              }
            });
          });
        } else {
          alert("something went wrong please try again later");
        }
      });
  }
  fetchArchivedUsers(value) {
    const token = localStorage.getItem("access_token");
    let retries = 0;
    let {
      archivedUserType
    } = this.state;

    let fetchUsersURL = `${baseUrl}/admin/users?page=${value}&user_type=${archivedUserType}&archived=1`;
    if(this.state.archivedLastActiveStart && this.state.archivedLastActiveEnd) {
      fetchUsersURL += `&last_active[start]=${this.state.archivedLastActiveStart}&last_active[end]=${this.state.archivedLastActiveEnd}`;
    }

    if(this.state.archivedDateAddedStart && this.state.archivedDateAddedEnd) {
      fetchUsersURL += `&date_added[start]=${this.state.archivedDateAddedStart}&date_added[end]=${this.state.archivedDateAddedEnd}`;
    }

    fetch(fetchUsersURL, {
      method: "GET",
      headers: {
        Authorization: token,
        Accept: "application/json"
      }
    })
      .then(response => {
        const auth = response.headers.get("Authorization");
        localStorage.setItem("access_token", auth);
        if (response.status === 403) {
          localStorage.removeItem("access_token");
          return <Redirect to="/login" />;
        }
        return response.json();
      })
      .then(responseJson => {
        if (responseJson.meta.current_page === 1) {
          this.setState({
            archivedUsers: responseJson.data,
            archivedUsersTotalPages: responseJson.meta.last_page,
            totalArchivedUsers: responseJson.meta.total,
            archivedUserMore: responseJson.meta.total - 10,
            archivedUsersResponse: true
          });
        } else {
          for (let user in responseJson.data) {
            this.setState({
              archivedUsers: [
                ...this.state.archivedUsers,
                responseJson.data[user]
              ],
              archivedUsersTotalPages: responseJson.meta.last_page,
              totalArchivedUsers: responseJson.meta.total,
              archivedMoreResponse: true
            });
          }
        }
      })
      .catch(error => {
        if (error === 401 && retries < 1) {
          localStorage.getItem("access_token").then(value => {
            fetch(`${baseUrl}/token/refresh`, {
              headers: {
                Accept: "application/json",
                Authorization: value
              }
            }).then(response => {
              retries += 1;
              if (response.status === 200) {
                localStorage.setItem(
                  "access_token",
                  response.headers.get("Authorization")
                );
                this.handleSubmit();
              } else {
                alert("something went wrong please try again later");
              }
            });
          });
        } else {
          alert("something went wrong please try again later");
        }
      });
  }
  loadMore() {
    let nextPage = this.state.currentPage + 1;

    if (nextPage <= this.state.totalPages) {
      this.setState(
        {
          currentPage: this.state.currentPage + 1,
          more: this.state.more - 10,
          moreResponse: false
        },
        this.fetchUsers(nextPage)
      );
    }
  }
  loadMoreArchivedUsers() {
    let nextPage = this.state.archivedUsersCurrentPage + 1;

    if (nextPage <= this.state.archivedUsersTotalPages) {
      this.setState(
        {
          archivedUsersCurrentPage: this.state.archivedUsersCurrentPage + 1,
          archivedUserMore: this.state.archivedUserMore - 10,
          archivedMoreResponse: false
        },
        this.fetchArchivedUsers(nextPage)
      );
    }
  }
  showUser(id, type) {
    if (type === "caregiver") {
      localStorage.setItem("user_type", "care_giver");
    } else {
      localStorage.setItem("user_type", type);
    }
    localStorage.setItem("user_id", JSON.stringify(id));
    this.props.history.push(`/${type}`);
  }
  handleFilter(e) {
    this.setState(
      {
        userType: e.target.value,
        activeUserTypeSelected: true,
        currentPage: 1
      },
      this.state.tabValue === 0 ? this.fetchUsers : this.fetchArchivedUsers
    );
  }

  handleArchivedFilter(e) {
    this.setState(
      {
        archivedUserType: e.target.value,
        archivedUserTypeSelected: true,
        currentPage: 1
      },
      this.state.tabValue === 0 ? this.fetchUsers : this.fetchArchivedUsers
    );
  }

  handleTabChange(event, newValue) {
    this.setState({ tabValue: newValue });
  }

  handleDateChange({ startDate, endDate }) {
    this.setState({ startDate, endDate });
  }

  handleFocusChanged({ focusedInput }) {
    this.setState({ focusedInput });
  }

  handleExport(dataRows) {
    let currentTab = this.state.tabValue;
    let csvFileName = "";

    if (currentTab === 0) {
      csvFileName = "active-users.csv";
    } else {
      csvFileName = "archived-users.csv";
    }

    convertToCsv(csvFileName, dataRows);
  }

  setDateAdded(date) {
    this.setState({ dateAdded: date });
  }
  setLastActive(date) {
    this.setState({ lastActive: date });
  }

  toggleActiveUserFilter(event) {
    this.setState({ filterActiveUsers: !this.state.filterActiveUsers });
  }

  toggleArchivedUserFilter(event) {
    this.setState({ filterArchivedUsers: !this.state.filterArchivedUsers });
  }

  setStartDate(date) {
    this.setState({ startDate: date });
  }

  setEndDate(date) {
    this.setState({ endDate: date });
  }

  setFocusedInput(focusedInput) {
    this.setState({ focusedInput: focusedInput });
  }

  handleDatesChange = ({ startDate, endDate }) => {
    this.setStartDate(startDate);
    this.setEndDate(endDate);
  };

  clearActiveUserFilter() {
    this.setState(
      { activeUserTypeSelected: false, userType: "" },
      this.fetchUsers
    );
  }

  clearActiveDateAddedFilter() {
    this.setState(
      {
        startDateDateAddedActive: null,
        endDateDateAddedActive: null,
        activeDateAddedStart: null,
        activeDateAddedEnd: null,
        activeDateAddedSelected: false
      },
      this.fetchUsers
    );
  }

  clearActiveLastActiveFilter() {
    this.setState(
      {
        startDateLastActiveActive: null,
        endDateLastActiveActive: null,
        activeDateAddedStart: null,
        activeLastActiveEnd: null,
        activeLastActiveSelected: false
      },
      this.fetchUsers
    );
  }

  clearArchivedLastActiveFilter() {
    this.setState(
      {
        startDateLastActiveArchived: null,
        endDateLastActiveArchived: null,
        archivedLastActiveStart: null,
        archivedLastActiveEnd: null,
        archivedLastActiveSelected: false
      },
      this.fetchArchivedUsers
    );
  }

  clearArchivedDateAddedFilter() {
    this.setState(
      {
        startDateDateAddedArchived: null,
        endDateDateAddedArchived: null,
        archivedDateAddedStart: null,
        archivedDateAddedEnd: null,
        archivedDateAddedSelected: false
      },
      this.fetchArchivedUsers
    );
  }

  clearArchivedUserFilter() {
    this.setState({ archivedUserTypeSelected: null, archivedUserType: "" }, this.fetchArchivedUsers);
  }

  render() {
    return (
      <div className="users">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-lg-10 order-12 order-md-12 order-lg-1">
              {/* Tab goes here */}
              {/* <CalendarTable /> */}
              <Paper style={PaperStyle}>
                <Tabs
                  value={this.state.tabValue}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  centered
                >
                  <Tab label="Active Users" />
                  <Tab label="Archived Users" />
                </Tabs>

                <TabPanel value={this.state.tabValue} index={0}>
                  <div className="all-users">
                    <div className="top">
                      <h6>{this.state.totalUsers} Users</h6>
                      <div style={{ display: "flex" }}>
                        <FilterUserButton onClick={this.toggleActiveUserFilter}>
                          <FilterUsersSpan>
                            Filter Users
                          </FilterUsersSpan>
                          <i className="fa fa-caret-down"></i>
                        </FilterUserButton>

                        <Link to="/add-user">
                          <button>
                            <i className="fa fa-plus-circle"></i>Add new user
                          </button>
                        </Link>
                      </div>
                    </div>

                    <div
                      className={
                        "top " +
                        (this.state.filterActiveUsers
                          ? "active-users-filter-control"
                          : "active-users-filter-control-hidden")
                      }
                    >
                      <h6>Filter Users</h6>
                      <div style={{ display: "flex" }}>
                        <FilterItemWrapper>
                          <FilterUserSubHeading>
                            USER TYPE{" "}
                            {this.state.activeUserTypeSelected && (
                              <ClearFilterSpan
                                onClick={this.clearActiveUserFilter}
                              >
                                <span>clear filter</span>
                              </ClearFilterSpan>
                            )}
                          </FilterUserSubHeading>
                          <FilterSelect
                            onChange={this.handleFilter}
                            value={this.state.userType}
                            style={FilterUserBtnStyle}
                          >
                            <option value="">All</option>
                            <option value="patient">Patient</option>
                            <option value="caregiver">Caregiver</option>
                          </FilterSelect>
                        </FilterItemWrapper>

                        <FilterItemWrapper>
                          <FilterUserSubHeading>
                            Date added{" "}
                            {this.state.activeDateAddedSelected && (
                              <ClearFilterSpan
                                onClick={this.clearActiveDateAddedFilter}
                              >
                                <span>clear filter</span>
                              </ClearFilterSpan>
                            )}
                          </FilterUserSubHeading>
                          <FilterDateRange style={FilterUserBtnStyle}>
                            <div className="App">
                              <DateRangePicker
                                startDate={this.state.startDateDateAddedActive}
                                startDateId="startDateDateAddedActive"
                                endDate={this.state.endDateDateAddedActive}
                                endDateId="endDateDateAddedActive"
                                isOutsideRange={() => false}
                                onDatesChange={({ startDate, endDate }) => {
                                  let sDate = moment(startDate).format(
                                    "YYYY-MM-DD"
                                  );
                                  let eDate = moment(endDate).format(
                                    "YYYY-MM-DD"
                                  );
                                  this.setState({
                                    startDateDateAddedActive: startDate,
                                    endDateDateAddedActive: endDate,
                                    activeDateAddedStart: sDate,
                                    activeDateAddedEnd: eDate,
                                    activeDateAddedSelected: true
                                  });
                                }}
                                focusedInput={
                                  this.state.focusedInputDateAddedActive
                                }
                                onClose={() =>
                                  this.setState({}, this.fetchUsers)
                                }
                                onFocusChange={focusedInput =>
                                  this.setState({
                                    focusedInputDateAddedActive: focusedInput
                                  })
                                }
                              />
                            </div>
                          </FilterDateRange>
                        </FilterItemWrapper>

                        <FilterItemWrapper>
                          <FilterUserSubHeading>
                            Last Active{" "}
                            {this.state.activeLastActiveSelected && (
                              <ClearFilterSpan
                                onClick={this.clearActiveLastActiveFilter}
                              >
                                <span>clear filter</span>
                              </ClearFilterSpan>
                            )}
                          </FilterUserSubHeading>
                          <FilterDateRange style={FilterUserBtnStyle}>
                            <DateRangePicker
                              startDateId="startDateLastActiveActive"
                              endDateId="endDateLastActiveActive"
                              isOutsideRange={() => false}
                              startDate={this.state.startDateLastActiveActive}
                              endDate={this.state.endDateLastActiveActive}
                              onDatesChange={({ startDate, endDate }) => {
                                let sDate = moment(startDate).format(
                                  "YYYY-MM-DD"
                                );
                                let eDate = moment(endDate).format(
                                  "YYYY-MM-DD"
                                );
                                this.setState({
                                  startDateLastActiveActive: startDate,
                                  endDateLastActiveActive: endDate,
                                  activeLastActiveStart: sDate,
                                  activeLastActiveEnd: eDate,
                                  activeLastActiveSelected: true
                                });
                              }}
                              focusedInput={
                                this.state.focusedInputLastActiveActive
                              }
                              onClose={() => this.setState({}, this.fetchUsers)}
                              onFocusChange={focusedInput => {
                                this.setState({
                                  focusedInputLastActiveActive: focusedInput
                                });
                              }}
                            />
                          </FilterDateRange>
                        </FilterItemWrapper>
                      </div>
                    </div>
                    <table className="active-user-table">
                      <tbody>
                        <tr>
                          <th>Name</th>
                          <th>Alias</th>
                          <th>Date Added</th>
                          <th>User Type</th>
                          <th>Last Active</th>
                          <th>Contact</th>
                        </tr>
                        {!this.state.response && (
                          <tr className="loader">
                            <td>
                              <img src={loader} alt="" />
                            </td>
                          </tr>
                        )}
                        {this.state.users.map((user, index) => {
                          let dateAdded = user.date_added
                            .split("-")
                            .reverse()
                            .join("-");
                          dateAdded = moment(dateAdded).format("DD/MM/YYYY");
                          let lastActive = user.last_active
                            .split("-")
                            .reverse()
                            .join("-");
                          lastActive = moment(lastActive).format("DD/MM/YYYY");
                          let patientTag =
                            user.user_type === "patient"
                              ? "patient-tag"
                              : "caregiver-tag";
                          return (
                            <tr
                              className="user-row"
                              key={index}
                              onClick={() =>
                                this.showUser(user.id, user.user_type)
                              }
                            >
                              <td>{user.name}</td>
                              <td>{user.alias}</td>
                              <td>{dateAdded}</td>
                              <td>
                                <p className={patientTag}>{user.user_type}</p>
                              </td>
                              <td>{lastActive}</td>
                              <td className="contact">{user.contact}</td>
                              <td className="edit">
                                <EditButton>Edit</EditButton>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="more-div">
                      {this.state.response &&
                        this.state.more > 0 &&
                        this.state.moreResponse && (
                          <p
                            className="more-text"
                            onClick={() => this.loadMore()}
                          >
                            <i className="fa fa-plus-circle"></i>Load more users
                            ({this.state.more})
                          </p>
                        )}
                      {!this.state.moreResponse && (
                        <img src={smallLoader} alt="" />
                      )}
                    </div>
                  </div>
                </TabPanel>
                {/* Archived users */}

                <TabPanel value={this.state.tabValue} index={1}>
                  <div className="all-users">
                    <div className="top">
                      <h6>{this.state.totalArchivedUsers} Users</h6>
                      <div style={{ display: "flex" }}>
                        <FilterUserButton onClick={this.toggleArchivedUserFilter}>
                          <FilterUsersSpan>
                            Filter Users
                          </FilterUsersSpan>
                          <i className="fa fa-caret-down"></i>
                        </FilterUserButton>

                        <Link to="/add-user">
                          <button>
                            <i className="fa fa-plus-circle"></i>Add new user
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div
                      className={
                        "top " +
                        (this.state.filterArchivedUsers
                          ? "archived-users-filter-control"
                          : "archived-users-filter-control-hidden")
                      }
                    >
                      <h6>Filter Users</h6>
                      <div style={{ display: "flex" }}>
                        <FilterItemWrapper>
                          <FilterUserSubHeading>
                            USER TYPE{" "}
                            {this.state.archivedUserTypeSelected && (
                              <ClearFilterSpan
                                onClick={this.clearArchivedUserFilter}
                              >
                                <span>clear filter</span>
                              </ClearFilterSpan>
                            )}
                          </FilterUserSubHeading>
                          <FilterSelect
                            onChange={this.handleArchivedFilter}
                            value={this.state.archivedUserType}
                            style={FilterUserBtnStyle}
                          >
                            <option value="">All</option>
                            <option value="patient">Patient</option>
                            <option value="caregiver">Caregiver</option>
                          </FilterSelect>
                        </FilterItemWrapper>

                        <FilterItemWrapper>
                          <FilterUserSubHeading>
                            Date added{" "}
                            {this.state.archivedDateAddedSelected && (
                              <ClearFilterSpan
                                onClick={this.clearArchivedDateAddedFilter}
                              >
                                <span>clear filter</span>
                              </ClearFilterSpan>
                            )}
                          </FilterUserSubHeading>
                          <FilterDateRange style={FilterUserBtnStyle}>
                            <DateRangePicker
                              startDate={this.state.startDateDateAddedArchived}
                              startDateId="startDateDateAddedArchived"
                              endDate={this.state.endDateDateAddedArchived}
                              endDateId="endDateDateAddedArchived"
                              isOutsideRange={() => false}
                              onDatesChange={({ startDate, endDate }) => {
                                let sDate = moment(startDate).format(
                                  "YYYY-MM-DD"
                                );
                                let eDate = moment(endDate).format(
                                  "YYYY-MM-DD"
                                );
                                this.setState({
                                  startDateDateAddedArchived: startDate,
                                  endDateDateAddedArchived: endDate,
                                  archivedDateAddedStart: sDate,
                                  archivedDateAddedEnd: eDate,
                                  archivedDateAddedSelected: true
                                });
                              }}
                              focusedInput={
                                this.state.focusedInputDateAddedArchived
                              }
                              onClose={() =>
                                this.setState({}, this.fetchArchivedUsers)
                              }
                              onFocusChange={focusedInput =>
                                this.setState({
                                  focusedInputDateAddedArchived: focusedInput
                                })
                              }
                            />
                          </FilterDateRange>
                        </FilterItemWrapper>

                        <FilterItemWrapper>
                          <FilterUserSubHeading>
                            Last Active{" "}
                            {this.state.archivedLastActiveSelected && (
                              <ClearFilterSpan
                                onClick={this.clearArchivedLastActiveFilter}
                              >
                                <span>clear filter</span>
                              </ClearFilterSpan>
                            )}
                          </FilterUserSubHeading>
                          <FilterDateRange style={FilterUserBtnStyle}>
                            <DateRangePicker
                              startDateId="startDateLastActiveArchived"
                              endDateId="endDateLastActiveArchived"
                              isOutsideRange={() => false}
                              startDate={this.state.startDateLastActiveArchived}
                              endDate={this.state.endDateLastActiveArchived}
                              onDatesChange={({ startDate, endDate }) => {
                                let sDate = moment(startDate).format(
                                  "YYYY-MM-DD"
                                );
                                let eDate = moment(endDate).format(
                                  "YYYY-MM-DD"
                                );
                                this.setState({
                                  startDateLastActiveArchived: startDate,
                                  endDateLastActiveArchived: endDate,
                                  archivedLastActiveStart: sDate,
                                  archivedLastActiveEnd: eDate,
                                  archivedLastActiveSelected: true
                                });
                              }}
                              focusedInput={
                                this.state.focusedInputLastActiveArchived
                              }
                              onClose={() => this.setState({}, this.fetchArchivedUsers)}
                              onFocusChange={focusedInput => {
                                this.setState({
                                  focusedInputLastActiveArchived: focusedInput
                                });
                              }}
                            />
                          </FilterDateRange>
                        </FilterItemWrapper>
                      </div>
                    </div>
                    <table className="archived-user-table">
                      <tbody>
                        <tr>
                          <th>Name</th>
                          <th>Alias</th>
                          <th>Date Added</th>
                          <th>User Type</th>
                          <th>Last Active</th>
                          <th>Contact</th>
                        </tr>
                        {!this.state.response && (
                          <tr className="loader">
                            <td>
                              <img src={loader} alt="" />
                            </td>
                          </tr>
                        )}
                        {this.state.archivedUsers.map((user, index) => {
                          let dateAdded = user.date_added
                            .split("-")
                            .reverse()
                            .join("-");
                          dateAdded = moment(dateAdded).format("DD/MM/YYYY");
                          let lastActive = user.last_active
                            .split("-")
                            .reverse()
                            .join("-");
                          lastActive = moment(lastActive).format("DD/MM/YYYY");
                          let patientTag =
                            user.user_type === "patient"
                              ? "patient-tag"
                              : "caregiver-tag";
                          return (
                            <tr
                              className="user-row"
                              key={index}
                            >
                              <td onClick={() =>
                                this.showUser(user.id, user.user_type)
                              }>{user.name}</td>
                              <td onClick={() =>
                                this.showUser(user.id, user.user_type)
                              }>{user.alias}</td>
                              <td onClick={() =>
                                this.showUser(user.id, user.user_type)
                              }>{dateAdded}</td>
                              <td onClick={() =>
                                this.showUser(user.id, user.user_type)
                              }>
                                <p className={patientTag}>{user.user_type}</p>
                              </td>
                              <td onClick={() =>
                                this.showUser(user.id, user.user_type)
                              }>{lastActive}</td>
                              <td onClick={() =>
                                this.showUser(user.id, user.user_type)
                              } className="contact">{user.contact}</td>
                              <td className="edit">
                                <EditButton onClick={() => {
                                  this.setState({showModal: !this.state.showModal, selectedUserType: user.user_type, selectedUserId: user.id})
                                }}>Restore</EditButton>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="more-div">
                      {this.state.archivedUsersResponse &&
                        this.state.archivedUserMore > 0 &&
                        this.state.archivedMoreResponse && (
                          <p
                            className="more-text"
                            onClick={() => this.loadMoreArchivedUsers()}
                          >
                            <i className="fa fa-plus-circle"></i>Load more users
                            ({this.state.archivedUserMore})
                          </p>
                        )}
                      {!this.state.archivedMoreResponse && (
                        <img src={smallLoader} alt="" />
                      )}
                    </div>
                  </div>
                </TabPanel>
                {/* Archived users end here */}
              </Paper>
              {/* Tab Ends Here */}
            </div>

            <div className="col-md-12 col-lg-2 order-1 order-md-1 order-lg-12 mb-3">
              <div className="users-div">
                <p>Users</p>
                <h6>
                  <span className="yellow">30</span>Patients
                </h6>
                <h6>
                  <span className="green">6</span>Caregivers
                </h6>
              </div>
              <div className="export-users">
                <p>Export Users</p>
                <button
                  // onClick={this.fetchExportData}
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-download"></i>Export user data
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <div className="dropdown-item" onClick={this.fetchExportData}>
                    Download All
                  </div>
                  <div
                    className="dropdown-item"
                    onClick={this.handleFilteredExport}
                  >
                    Download Filtered
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={this.state.showModal} handleClose={()=>this.setState({showModal: false})}>
          {this.state.showModal && (
            <ConfirmPassword
              action='restore'
              userType={this.state.selectedUserType}
              userID={this.state.selectedUserId}
            />
          )}
        </Modal>
      </div>
    );
  }
}

export default withRouter(Users);



// WEBPACK FOOTER //
// ./src/components/Users.js